import { Input } from "../ui/input";
import { CATEGORY } from "../../lib/labels";

export default function ScopeFilters({ value, onChange, agencies, services, withDates = true }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value, ...(k === "agency_id" ? { service_id: "" } : {}) });
  return (
    <div className="card-surface mb-6 grid gap-2 p-4 sm:grid-cols-2 lg:grid-cols-5" data-testid="scope-filters">
      {withDates && <label className="text-xs text-slate-500">Du<Input type="date" value={value.date_from} onChange={set("date_from")} data-testid="stats-date-from" /></label>}
      {withDates && <label className="text-xs text-slate-500">Au<Input type="date" value={value.date_to} onChange={set("date_to")} data-testid="stats-date-to" /></label>}
      <select className="field-select self-end" value={value.agency_id} onChange={set("agency_id")} data-testid="stats-agency">
        <option value="">Toutes agences</option>{(agencies || []).map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
      </select>
      <select className="field-select self-end" value={value.service_id} onChange={set("service_id")} data-testid="stats-service">
        <option value="">Tous services</option>{(services || []).filter((s) => !value.agency_id || s.agency_id === value.agency_id).map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
      <select className="field-select self-end" value={value.category} onChange={set("category")} data-testid="stats-category">
        <option value="">Toutes catégories</option>{Object.entries(CATEGORY).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
    </div>
  );
}
